import React, { useState } from "react";
import { Box, Typography, Divider } from "@mui/material";
import { useTranslationContext } from "../../../../hooks/translations/translationsProvider";
import BuyListTable from "./PurchasesTable";

const PurchasesManagement: React.FC = () => {
    const {t} = useTranslationContext();
    return (
        <Box >
            <Typography variant="h3" gutterBottom>
                {t("Gestione Acquisti")}
            </Typography>

            <Divider sx={{ mb: 3, mt:3 }} />

            <Typography variant="h5" gutterBottom>
                {t("Acquisti")}
            </Typography>
            
            <BuyListTable />


        </Box>
    );
};

export default PurchasesManagement;
